const ml = 'margin-left';
const mr = 'margin-right';
const mt = 'margin-top';
const mb = 'margin-bottom';
const pl = 'padding-left';
const pr = 'padding-right';
const pt = 'padding-top';
const pb = 'padding-bottom';

const dict = {
  ml,
  mr,
  mt,
  mb,
  // margin-horizontal
  mh: [ml, mr],
  // margin-vertical
  mv: [mt, mb],

  pl,
  pr,
  pt,
  pb,
  // padding-horizontal
  ph: [pl, pr],
  // padding-vertical
  pv: [pt, pb],
};

// TODO: Add correct types instead of any and remove @ts-ignore
const template = (prop: any, value: any) => `${prop}: ${value}em;`;

export const generateIndents = (props: any) => {
  const dictKeys = Object.keys(dict);
  const propsKeys = Object.keys(props);

  return propsKeys.map(propKey => {
    if (dictKeys.includes(propKey)) {
      // @ts-ignore
      const cssProp = dict[propKey];
      const value = props[propKey];

      if (Array.isArray(cssProp)) {
        return cssProp
          .map(cssPropFromArray => template(cssPropFromArray, value))
          .join('');
      }

      return template(cssProp, value);
    }
  });
};
